import makeStyles from '@material-ui/core/styles/makeStyles'
import React, { useEffect, useState, useCallback } from 'react'
import useDebounce from '../../../services/customHooks/useDebounce'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'
import Checkbox from '@mui/material/Checkbox'

const MultiEntitySearch = ({
  disabled,
  allowMultiSelection = true,
  searchMoreCallback,
  searchEntitySubType,
  searchNoSystem = false,
  className,
  setSelection,
  selection,
  equalityEvaluator = null,
  isAddOnly = false
}) => {
  const classes = useStyles({ disabled })
  const [searchResult, setSearchResult] = useState([])
  const [selectedResult, setSelectedResult] = useState(selection)

  const nakedUpdateSearchWord = e => {
    const newValue = e?.target?.value || ''
    if (newValue.length > 1 || !newValue) localFetchHandle(newValue)
  }

  // the accumulated user input only causes one server poll every half a second
  const debouncedUpdateSearchWord = useDebounce(nakedUpdateSearchWord, 500)

  const localFetchHandle = useCallback(
    async keywords => {
      const rawSearchResult = await searchMoreCallback(
        keywords,
        searchEntitySubType,
        searchNoSystem
      )
      setSearchResult(rawSearchResult)
    },
    [searchMoreCallback, searchEntitySubType, searchNoSystem]
  )

  useEffect(() => {
    setSelectedResult(selection)
  }, [selection])

  const isEqual = (option, value) => {
    if (option.hasOwnProperty('id') && value.hasOwnProperty('id')) {
      return option.id === value.id
    }

    if (option.hasOwnProperty('id') && typeof value === 'string') {
      return option.id === value
    }

    return equalityEvaluator(option, value)
  }

  return (
    <Autocomplete
      className={`${classes.root} ${className}`}
      multiple={allowMultiSelection}
      autoComplete={true}
      value={selectedResult}
      disableCloseOnSelect
      disableClearable={isAddOnly}
      disabled={disabled}
      options={searchResult}
      getOptionLabel={o => o.name}
      isOptionEqualToValue={isEqual}
      noOptionsText={''}
      filterSelectedOptions={isAddOnly}
      onChange={(e, val, reason) => {
        if (isAddOnly && (reason === 'removeOption' || reason === 'clear')) return
        setSelectedResult(val)
        setSelection(val)
      }}
      onBlur={() => {
        setTimeout(() => {
          setSearchResult([])
        })
      }}
      renderInput={params => (
        <TextField
          {...params}
          onChange={debouncedUpdateSearchWord}
          onClick={nakedUpdateSearchWord}
          placeholder="Start typing..."
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            )
          }}
          variant='outlined'
        />
      )}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props

        return <li key={key} {...optionProps}>
          <Checkbox style={{ marginRight: 8 }} checked={selected} />
          {option.name}
        </li>
      }}
    />
  )
}

const useStyles = makeStyles((theme, props) => ({
  root: {
    padding: '0 0 5px 0',
    display: props => (props.disabled ? 'none' : 'block'),
    // maxWidth: '400px',
    // border: `1px solid ${theme.palette.tertiary.accent}`,
    // borderRadius: '5px',

    '& .MuiInputBase-root': {
      padding: 0
    },
    '& .MuiAutocomplete-inputRoot': {
      maxHeight: '29px'
    },
    '& .MuiInputBase-input': {
      height: '10px',
      fontSize: '12px'
    },
    '& .MuiFormControl-root': {
      border: `1px solid ${theme.palette.tertiary.accent}`,
      borderRadius: '5px'
    },
    '& .MuiSvgIcon-root': {
      padding: '3px'
    }
  }
}))

export default React.memo(MultiEntitySearch)
